(function(global) {
    'use strict';
    
    var mms = global.mms || (global.mms = {}),
        title;
    
    function Title(el) {
        this.el = el;

        mms.state.signals.changeHighlight.add(this.changeHighlight, this);
        mms.state.signals.changePainting.add(this.changePainting, this);
        
        this.chars = Title.TEXT.split("");
        this.charsVisible = 0;
        this.underscore = false;
    }
    Title.TEXT = "Trīs gleznu noslēpumi";
    Title.prototype = {
        changeHighlight: function(prevValue) {
            if (!this.updateId) {
                this.update();
                this.render();
                setInterval(_.bind(this.toggleUnderscore, this), 500);
            }
        },
        changePainting: function(prevValue) {
            if (mms.state.painting) {
                clearTimeout(this.updateId);
                TweenLite.killTweensOf(this.el);
                this.fade(0, 0, 0.5);
            }
            else {
                this.fade(1, 0, 0.5, 1, _.bind(this.update, this));
            }
        },
        update: function() {
            this.updateId = setTimeout(_.bind(this.updateText, this), (250+Math.random()*500)*0.667);
        },
        render: function() {
            var textVisible = this.chars.slice(0, this.charsVisible).join(""),
                textHidden = this.chars.slice(this.charsVisible).join(""),
                html = textVisible;
            //html += '<i class="fa fa-i-cursor" style="'+(this.underscore && textVisible && textVisible != Title.TEXT ? '' : 'color:transparent')+'"></i>';
            //html += '<span style="'+(this.underscore && textVisible && textVisible != Title.TEXT ? '' : 'color:transparent')+'">_</span>';
            html += '<span style="color:transparent">'+textHidden+'</span>';
            this.el.innerHTML = html;
            requestAnimationFrame(_.bind(this.render, this));
        },
        toggleUnderscore: function() {
            this.underscore = !this.underscore;
        },
        updateText: function() {
            if (this.charsVisible < this.chars.length) {
                this.charsVisible = this.charsVisible+1;
                mms.sounds.key({volume: 0.4+Math.random()*0.6});
                this.update();
            }
            else {
                var self = this;
                this.fade(0, 5, 15, 15, function() {
                    self.charsVisible = 0;
                    self.fade(1, 5, 0, 1, _.bind(self.update, self));
                });
            }
        },
        fade: function(value, blur, duration, delay, callback) {
            var self = this;
            TweenLite.to(this.el, duration, {
                css:{autoAlpha: value}, 
                ease: Sine.easeIn,
                delay: delay || 0,
                onUpdate: function() {
                    var blurVal = (this.progress()*blur).toFixed(2);
                    if (value) {
                        blurVal = blur - blurVal;
                    }
                    self.el.style.webkitFilter = 'blur('+blurVal+'px)';
                },
                onComplete: callback || function() {}
            });
        }
    };
    
    mms.Title = Title;
    mms.title = new Title(document.getElementById("title"));
  
})(this);